import { Session } from "./session";
export class Exam {
    constructor(examWrapper, certificateId) {
        this.certificateId = certificateId;
        this.examId = examWrapper.dataset.examId;
        this.button = examWrapper.querySelector(Exam.addExamButtonSelector);
        this.examSessionWrapper = examWrapper.querySelector(Exam.examSessionsWrapperSelector(this.examId));
        this.session = new Session(this.examSessionWrapper, this.certificateId, this.button, this.examId);
        this.button.addEventListener("click", () => this.session.activate());
    }
    activate() { }
    deactivate() {
        this.session.deactivate();
    }
    addToFormData(formData) {
        this.session.addToFormData(formData);
    }
    validate() {
        return this.session.validate();
    }
    hasSession() {
        return this.session.isActive();
    }
}
Exam.addExamButtonSelector = ".js-add-exam";
Exam.examSessionsWrapperSelector = (examId) => `.js-sessions-${examId}`;
